/*
 *
 * Authorization API Constants
 *
 */

import { SERVICE_NAMESPACE } from 'common';
import { getAppConfigSetting } from '../../utils';

export const NAMESPACE = `${SERVICE_NAMESPACE}/createSsoLogin`;

export const URL = `${getAppConfigSetting('legitUrl')}/legit/api/v2/session/sso`;

export const NOT_ASKED = `${NAMESPACE}/NOT_ASKED`;

export const MAKE_REQUEST = `${NAMESPACE}/MAKE_REQUEST`;

export const LOADING = `${NAMESPACE}/LOADING`;

export const FAILURE = `${NAMESPACE}/FAILURE`;

export const SUCCESS = `${NAMESPACE}/SUCCESS`;



// WEBPACK FOOTER //
// ./src/services/SsoLogin/constants.js